import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'

import { useIntl } from 'react-intl'
import { useLocation } from 'react-router'
import downLoadGray from 'src/assets/images/common/downloadGray.svg'
import downLoad from 'src/assets/images/common/downloadWhite.svg'
import checkboxStore from 'src/stores/CheckboxStore'
import TableActionsBlock from 'src/utils/components/CustomTable/components/TableActionsBlock/TableActionsBlock'
import TableSortIcon from '../../../../components/customElements/TableSortIcon/TableSortIcon'
import NameReport from '../../../../components/reports/NameReport'
import {
  isAdmin,
  isAdministration,
  isDealer,
} from '../../../../services/AccountService'
import TableScrollButtons from '../../../../utils/components/CustomTable/components/TableScrollButtons/TableScrollButtons'
import StackActionStore from '../../../../utils/components/StackActions/StackActionStore'
import {
  closeModalFn,
  openModalFn,
} from '../../../../utils/controllers/ModalController'
import { debounce } from '../../../../utils/debounce/debounce'
import ParamsFilterStore from '../../../SummaryStatisticsDealers/store/ParamsFilterStore'
import summaryStatisticsDealersStoreInstance from '../../../SummaryStatisticsDealers/store/SummaryStatisticsDealersStore'
import NewRequestFilters from '../NewRequestFilters/NewRequestFilters'
import NoDataFound from './components/NoDataFound'
import { getTableRowTypographySx, tableRowBoxSx } from './consts/styles.const'
import HeadCheckbox from './HeadCheckbox'
import MassOperations from './MassOperations'
import store from './RequestsTableOptimizedStore'
import TableOptimizedRow from './TableOptimizedRow'
import { getCellSx } from './utils/getCellSx'

const RequestsTableOptimized = ({
  selectAllMode = false,
  filter,
  ordersStore,
  onRowClick,
  showPagination = true,
  filterStore,
  selectOrdersStore,
  withScrollButtons,
  selectedCol,
  setSelectedCol,
  hideMassOperations,
  RequestsFiltersFeature,
  minHeight,
  handleDeleteFromReport,
  onBtnClick,
}) => {
  const {
    data,
    addServiceProps,
    clearSelectOrders,
    getIdSelectedOrders,
    firstItem,
    isSomeChecked,
    logout,
  } = store
  const { pathname } = useLocation()
  const { closeRequest, dealerName, titleDate } =
    summaryStatisticsDealersStoreInstance
  const intl = useIntl()

  const [inputValue, setInputValue] = useState(ordersStore.pageNumber + 1)
  const [stackActionStore] = useState(new StackActionStore({ store: store }))
  const [newRowsFront, setNewRowsFront] = useState([])
  const { collection } = ordersStore
  const { params, loadFile } = ParamsFilterStore

  const hideCheckbox =
    pathname !== '/requests' &&
    isDealer() &&
    (ordersStore.collection[0]?.reportStatus !== 1 ?? true)

  const columns = [
    {
      propName: 'status',
      label: 'Статус',
      width: isAdministration() ? '60px' : null,
      isVisible: true,
    },
    {
      propName: 'financialSourceId',
      label: 'Оплата',
      sort: 'financial-source',
      handleClick: 'financial-source',
      isVisible: true,
    },
    {
      propName: 'dealer',
      label: 'Дилер',
      isVisible: true,
    },
    {
      propName: 'sender',
      label: 'Источник',
      isVisible: true,
    },
    {
      propName: 'id',
      label: 'Номер заявки',
      sort: 'id',
      handleClick: 'id',
      aline: 'left',
      textAlign: 'left',
      isVisible: true,
    },
    {
      propName: 'senderGroup',
      label: 'Источник',
      isVisible: true,
    },
    {
      propName: 'created',
      label: 'Дата создания',
      sort: 'created',
      handleClick: 'created',
      aline: 'center',
      isVisible: true,
    },
    {
      propName: 'installationDate',
      label: 'Дата установки',
      sort: 'installed',
      handleClick: 'installed',
      aline: 'center',
      isVisible: true,
    },
    {
      propName: 'fullName',
      label: 'ФИО',
      sort: isAdministration() ? null : 'fullname',
      handleClick: isAdministration() ? null : 'fullname',
      isVisible: true,
    },
    {
      propName: 'address',
      label: 'Адрес',
      sort: isAdministration() ? null : 'locality',
      handleClick: isAdministration() ? null : 'locality',
      isVisible: true,
    },
    {
      propName: 'phone',
      label: isAdmin() ? 'Номер телефона' : 'Телефон',
      aline: 'left',
      isVisible: true,
    },
    {
      propName: 'categories',
      label: 'Льготная категория',
      aline: 'left',
      textAlign: 'left',
      isVisible: true,
    },
    {
      propName: 'deleteRequest',
      handleClick: handleDeleteFromReport,
      isVisible:
        pathname.startsWith('/reports') &&
        isDealer() &&
        (ordersStore.collection[0]?.reportStatus === 1 ?? true),
      width: !hideCheckbox ? '60px' : null,
    },
  ].filter((el) => {
    if (isDealer()) {
      const hideEl = el.propName === 'senderGroup' && hideCheckbox

      return (
        el.propName !== 'dealer' &&
        el.propName !== 'categories' &&
        el.propName !== 'sender' &&
        !hideEl &&
        el.isVisible
      )
    } else if (!isAdministration()) {
      return (
        el.propName !== 'categories' &&
        el.propName !== 'senderGroup' &&
        el.propName !== 'deleteRequest'
      )
    } else {
      return el.propName !== 'senderGroup' && el.propName !== 'deleteRequest'
    }
  })

  useEffect(() => {
    if (ordersStore?._loadStatus === 'loaded') {
      addServiceProps(collection)
      closeModalFn['progress-backdrop']?.()
    }
    getIdSelectedOrders()
  }, [collection, ordersStore?._loadStatus])

  useEffect(() => {
    if (selectAllMode) {
      store.selectAllMode = true
    }

    if (ordersStore?._loadStatus !== 'loaded') {
      openModalFn?.['progress-backdrop']?.()
    }

    return () => {
      store.selectAllMode = false
      store.clearSelectOrders()
      logout()
      ordersStore.pageSize = 100
    }
  }, [])

  const onPageChange = useCallback(
    (event, page) => {
      if (page >= 0) {
        ordersStore.loadPageAction(page)
      }
    },
    [ordersStore],
  )

  const onPageSizeChange = useCallback(
    (event) => {
      ordersStore.pageSize = event.target.value
      onPageChange(0, 0)
    },
    [onPageChange, ordersStore],
  )

  const handleSort = (column) => {
    if (column.handleClick) {
      ordersStore.reversPage(column.handleClick)
    }
  }
  // reset pageSize on page change
  useEffect(() => {
    if (ordersStore.pageSize !== 100) {
      ordersStore.pageSize = 100
    }
  }, [pathname])

  return (
    <TableContainer
      sx={{
        borderRadius: '8px',
        marginTop: '0px',
        minHeight: minHeight ?? '80vh',
      }}
      component={Paper}
      id='custom-table-container'
    >
      <Box>
        {filter ? (
          <CurrentFilters
            closeRequest={closeRequest}
            data={data}
            dealerName={dealerName}
            filterStore={filterStore}
            loadFile={loadFile}
            onBtnClick={onBtnClick}
            ordersStore={ordersStore}
            params={params}
            selectOrdersStore={selectOrdersStore}
            store={store}
            titleDate={titleDate}
          />
        ) : null}

        {RequestsFiltersFeature && <RequestsFiltersFeature />}
      </Box>
      <TableActionsBlock
        rows={data}
        actionsBlock={
          filter || hideMassOperations ? null : (
            <MassOperations
              stackActionStore={stackActionStore}
              status={firstItem?.status}
              collection={data}
            />
          )
        }
        showPagination={showPagination}
        total={ordersStore.total}
        setInputValue={setInputValue}
        pageSize={ordersStore.pageSize}
        inputValue={inputValue}
        page={ordersStore.pageNumber}
        rowsPerPageOptions={[50, 100, 200, 300, 400, 500]}
        onPageSizeChange={onPageSizeChange}
        onPageChange={debounce(clearSelectOrders, onPageChange, 300)}
        doublePagination={true}
        setNewRowsFront={setNewRowsFront}
      >
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell />
              {!hideCheckbox && <HeadCheckbox />}
              {columns.map((column) => {
                const isReverse =
                  ordersStore.checkIsRevers(column.sort) && selectedCol

                return (
                  <TableCell
                    key={column.propName}
                    onClick={() => {
                      handleSort(column)
                      column.sort && setSelectedCol(column.propName)
                    }}
                    sx={getCellSx(column, selectedCol)}
                  >
                    <Box sx={tableRowBoxSx(column)}>
                      <Typography sx={getTableRowTypographySx(column)}>
                        {column.label}
                      </Typography>
                      {column.sort && <TableSortIcon isReverse={isReverse} />}
                    </Box>
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => {
              return (
                <TableOptimizedRow
                  store={store}
                  index={i}
                  columns={columns}
                  row={row}
                  click={onRowClick}
                  withCheckBox={!hideCheckbox}
                  key={i}
                />
              )
            })}
          </TableBody>
        </Table>
        {(!ordersStore.total || !ordersStore.isLoaded) && (
          <NoDataFound length={data?.length} isLoaded={ordersStore?.isLoaded} />
        )}
        {withScrollButtons && !!ordersStore?.collection?.length && (
          <TableScrollButtons rowsLength={!!ordersStore?.collection?.length} />
        )}
      </TableActionsBlock>
    </TableContainer>
  )
}

const CurrentFilters = observer(
  ({
    closeRequest,
    dealerName,
    titleDate,
    params,
    store,
    ordersStore,
    filterStore,
    selectOrdersStore,
    onBtnClick,
    loadFile,
    data,
  }) => {
    const intl = useIntl()

    return (
      <Box mb={1} mr={3} ml={3} pt={1}>
        <NameReport
          onClose={closeRequest}
          reportTitle={`${dealerName}, Заявки за период ${titleDate}`}
          paddingX={'0'}
        />
        <Divider sx={{ marginBottom: '24px' }} />
        <NewRequestFilters
          SSDPageParams={params}
          gray
          filterRowStyles={{ background: '#fff' }}
          totalCollectionLength={store?.data?.length ? ordersStore.total : 0}
          filtersStore={filterStore}
          ordersStore={ordersStore}
          selectOrdersStore={selectOrdersStore}
          actionButtonProps={{
            name: intl.formatMessage({
              id: 'Сохранить в файл',
            }),
            onClick: onBtnClick ?? (() => loadFile(data)),
            icon: checkboxStore.selectedIds.length ? downLoad : downLoadGray,
            disabled: !checkboxStore.selectedIds.length,
          }}
          scrollIsAlreadyLocked
        />
        <Divider sx={{ marginTop: '24px' }} />
      </Box>
    )
  },
)

export default observer(RequestsTableOptimized)
